<template>
  <!-- Shown across the top of every demo Lens page so nobody mistakes the
  sample numbers for real performance -->
  <div class="w-full flex items-center gap-2 px-5 py-2 bg-secondary-yellow-10 border-b border-secondary-yellow-25">
    <InfoSimpleIcon
      :width="16"
      :height="16"
      class="flex-shrink-0 text-secondary-yellow-200"
    />
    <BaseText
      type="label"
      size="sm"
      class="text-secondary-yellow-300 flex-shrink-0"
    >
      Demo data
    </BaseText>
    <BaseText
      type="body"
      size="sm"
      class="text-secondary-yellow-300 truncate"
    >
      Sample numbers on Foreplay's own ads, not real performance.
    </BaseText>
  </div>
</template>

<script>
import posthog from 'posthog-js'
import InfoSimpleIcon from '../globals/Icons/InfoSimpleIcon.vue'

export default {
  name: 'LensDemoBanner',
  components: { InfoSimpleIcon },
  methods: {
    // The Lens page shows the creation flow, or the paywall on plans without Lens
    connectAccount () {
      posthog.capture('Lens Demo Banner Connect Clicked', { route: this.$route.name })
      this.$router.push({ name: 'LensView' }).catch(() => {})
    }
  }
}
</script>
